import React, { useMemo } from "react";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { useAppSelector } from "../../../store/configureStore";
import { getReportDetails } from "../../../store/reportDetails";
import { HardnessEquipment } from "../../forms/custom-hardness/hardnessEquipmentForm";
import { InfraredEquipment } from "../../forms/custom-infrared/infraredEquipmentForm";
import { Column } from "../../../utils/models";

import * as constants from "../../../utils/constants";
import * as utils from '../../../utils/utilities';

interface Props {
    infraredEquipmentItems: InfraredEquipment[];
}

const InfraredEquipmentReport: React.FC<Props> = ({ infraredEquipmentItems }) => {
    const { itemCountPerPage } = useAppSelector(getReportDetails);
    
    const equipmentColumns: Column[] = useMemo(() => {
		return [
			{
				path: 'equipmentName',
				label: 'Equipment Name',
			},
			{
				path: 'modal',
				label: 'Modal',
			},
			{
				path: 'equipmentSerialNumber',
				label: 'Serial Number',
			},
			{
				path: 'calibrationDueDate',
				label: 'Calibration Due Date',
				content: (equipment: HardnessEquipment) => utils.formatTime(equipment.calibrationDueDate, constants.APP_DATE_FORMAT),
			},
			{
				path: 'calibrationSerialNumber',
				label: 'Calibration Block Serial Number',
			},
			{
				path: 'material',
				label: 'Material',
			},
			{
				path: 'surfaceCondition',
				label: 'Surface Condition',
			},
			{
				path: 'stageOfInspection',
				label: 'Stage of Inspection',
			},
			{
				path: 'testMethod',
				label: 'Test Method',
			},
			{
				path: 'loadApplied',
				label: 'Load Applied (gram)',
			},
		];
	}, []);

	const equipmentWithSerialNumber = useMemo(() => {
		return infraredEquipmentItems.map((result, index) => ({
			id: index + 1,
			...result,
		}));
	}, [infraredEquipmentItems]);

    return ( 
        <React.Fragment>
			{utils.getChunkedData(equipmentWithSerialNumber, itemCountPerPage).map((chunk) => (
				<CustomSection sectionTitle="Equipment Details">
					<div className="p-1">
						<PDFTablePage data={chunk} columns={equipmentColumns} />
					</div>
				</CustomSection>
			))}
        </React.Fragment>
     );
}
 
export default InfraredEquipmentReport;